module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dialogHistory),
      expression: "!dialogHistory"
    }]
  }, [_c('el-row', [_c('el-col', {
    staticClass: "bigbolds",
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.displayTitle))])]), _vm._v(" "), _c('el-col', {
    staticClass: "bigbolds",
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.displayCTitle))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "bolds",
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.displaySchoolDate))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attendActive),
      expression: "attendActive"
    }]
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "float": "left"
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.getClasses
    }
  }, [_vm._v(" Back to Classes ")]), _vm._v(" "), (_vm.curClassDateActive) ? _c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.subAttendance
    }
  }, [_vm._v(" Submit " + _vm._s(_vm.newAttend) + " Attendance Sheet ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.classAttend,
      "border": "",
      "fit": "",
      "max-height": "800"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.displayInfo
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Students",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "bolds",
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.student_name) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "(學/学)生中文名字",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "link-type",
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              _vm.goEditStudentCName(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.chinese_name) + " ")]), _vm._v(" "), (scope.row.chinese_name == '') ? _c('span', {
          staticClass: "link-small",
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              _vm.goEditStudentCName(scope.row)
            }
          }
        }, [_vm._v("我的中文名字是? ")]) : _vm._e(), _vm._v(" "), (scope.row.notcname) ? _c('p') : _vm._e(), _vm._v(" "), (scope.row.notcname) ? _c('span', {
          staticClass: "notcname",
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v("像英文發音/寫中文名 ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (_vm.curClassDateActive) ? _c('el-table-column', {
    attrs: {
      "label": _vm.displayAttended,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.absence == 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          }
        }, [_vm._v(" Present ")]) : _vm._e(), _vm._v(" "), (scope.row.absence != 0) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.changeStatus(scope.$index, scope.row, 0)
            }
          }
        }) : _vm._e()]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.curClassDateActive) ? _c('el-table-column', {
    attrs: {
      "label": _vm.displayAbsence,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.absence != 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.changeStatus(scope.$index, scope.row, 1)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.absence == 1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          }
        }, [_vm._v(" Absent ")]) : _vm._e()]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.curClassDateActive) ? _c('el-table-column', {
    attrs: {
      "label": _vm.displayLate,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.absence == 2) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          }
        }, [_vm._v(" Late ")]) : _vm._e(), _vm._v(" "), (scope.row.absence !== 2) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.changeStatus(scope.$index, scope.row, 2)
            }
          }
        }) : _vm._e()]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.curClassDateActive) ? _c('el-table-column', {
    attrs: {
      "label": _vm.displayLeft,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.absence == 3) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          }
        }, [_vm._v(" Left ")]) : _vm._e(), _vm._v(" "), (scope.row.absence !== 3) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.changeStatus(scope.$index, scope.row, 3)
            }
          }
        }) : _vm._e()]
      }
    }])
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.attendActive && !_vm.dialogHistory),
      expression: "!attendActive &&  !dialogHistory"
    }]
  }, [_c('el-table', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "data": _vm.teacherClassesArr,
      "max-height": "800",
      "border": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Classes",
      "prop": "fullclass",
      "sortable": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Title",
      "prop": "title",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "classroom",
      "label": "Classroom ",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Take Attendance or 添加或修改中文名 ",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-icon-circle-check",
          attrs: {
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.getAttendance(scope.row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Attendance History ",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-icon-circle-check",
          attrs: {
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.getHistory(scope.row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Class List ",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-icon-circle-check",
          attrs: {
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.detailClass(scope.row)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogHistory),
      expression: "dialogHistory"
    }]
  }, [_c('el-row', [_c('el-col', {
    staticClass: "bolds",
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.DialogInfo))])])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-left": "30px",
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.doneHistory()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "bolds",
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "bolds"
  }, [_vm._v(" Show Certain Months ::: Begin Month ")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "Pick begin month"
    },
    on: {
      "change": _vm.dateBegin
    },
    model: {
      value: (_vm.monthB),
      callback: function($$v) {
        _vm.monthB = $$v
      },
      expression: "monthB"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bolds"
  }, [_vm._v("   End Month")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "Pick End month"
    },
    on: {
      "change": _vm.dateEnd
    },
    model: {
      value: (_vm.monthE),
      callback: function($$v) {
        _vm.monthE = $$v
      },
      expression: "monthE"
    }
  })], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.attendHistory,
      "max-height": "800",
      "border": ""
    },
    on: {
      "cell-click": _vm.getOneHist
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": "Students",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "bolds",
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.student_name) + " ")])]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.disCols), function(col) {
    return _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "formatter": _vm.formatCell
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.DialogInfo,
      "show-close": false,
      "visible": _vm.dialogOneHist,
      "size": "full"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogOneHist = $event
      }
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-bottom": "20px",
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.DoneOneHist()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.AttendanceEmail()
      }
    }
  }, [_vm._v("Send Attendance Email")]), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.classAttend,
      "max-height": "800",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.displayInfo
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Students",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "bolds",
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.student_name) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.displayAttended,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.absence == 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          }
        }, [_vm._v(" Present ")]) : _vm._e(), _vm._v(" "), (scope.row.absence != 0) ? _c('el-button', {
          attrs: {
            "size": "small"
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.displayAbsence,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.absence != 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.absence == 1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          }
        }, [_vm._v(" Absent ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.displayLate,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.absence == 2) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          }
        }, [_vm._v(" Late ")]) : _vm._e(), _vm._v(" "), (scope.row.absence !== 2) ? _c('el-button', {
          attrs: {
            "size": "small"
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.displayLeft,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.absence == 3) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          }
        }, [_vm._v(" Left ")]) : _vm._e(), _vm._v(" "), (scope.row.absence !== 3) ? _c('el-button', {
          attrs: {
            "size": "small"
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Email Absent Students",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.absence == 1) ? _c('span', {
          attrs: {
            "size": "small"
          }
        }, [_vm._v("  " + _vm._s(scope.row.email) + " ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Setup Email",
      "size": "full",
      "show-close": false,
      "visible": _vm.dialogTeacherForm
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTeacherForm = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.teacher_InputArr
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "Reply to (Email):",
            "label-width": _vm.formLabelWidth
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.email))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "Subject :",
            "label-width": _vm.formLabelWidth
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.subject))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "Message (Body)",
            "label-width": _vm.formLabelWidth
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.message))])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.EditTeacherCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.EditTeacher()
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Student Chinese Name (添加或修改中文名)",
      "show-close": false,
      "visible": _vm.dialogStudentForm
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogStudentForm = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.getrow
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "中文名",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.getrow.chinese_name),
      callback: function($$v) {
        _vm.getrow.chinese_name = $$v
      },
      expression: "getrow.chinese_name"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.EditStudentCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.EditStudent()
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.DialogInfo,
      "show-close": false,
      "visible": _vm.dialogClassCode,
      "size": "full"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogClassCode = $event
      }
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-bottom": "20px",
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.DoneDialogClassCode()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "20px",
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "document"
    },
    on: {
      "click": function($event) {
        _vm.handleDownload('')
      }
    }
  }, [_vm._v("EC list Excel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "20px",
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "document"
    },
    on: {
      "click": function($event) {
        _vm.handleDownload('pdf')
      }
    }
  }, [_vm._v("EC list PDF")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "20px",
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "document"
    },
    on: {
      "click": function($event) {
        _vm.handleDownload('cp')
      }
    }
  }, [_vm._v("For Simple Class Parent Excel")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.classAttendArr,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Date",
      "prop": "created",
      "sortable": "",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(scope.row.created)) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Students",
      "prop": "last_name",
      "sortable": "",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s(scope.row.student_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "chinese_name",
      "label": "中文名 ",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Parents",
      "prop": "father_lname",
      "sortable": "",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.father_fname) + " " + _vm._s(scope.row.father_lname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Parents2",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.parent2))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Email",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.email) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phone",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("phone")(scope.row.phone)) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "EC Person",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.ecp_name) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Medical Condition",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.medical_cond) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Allergy",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.allergy) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Dr. Name",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.doctor_name) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Dr. Phone",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.doctor_phone) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Medical Insurance",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.ins_company) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Insurance #",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.ins_policy) + " ")])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fbe5ab8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/attendance.vue
// module id = 269
// module chunks = 3